import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {App} from './App.tsx';
import {resolveSmtRuntime} from './runtime-port.ts';
import {signalAndroidRuntimeReady} from './runtime-carrier-ready.ts';
import '@morefunos/ui/tokens.css';
import '@morefunos/ui/base.css';
import './styles/global.css';
import './styles/p01.css';
import './styles/p01-modes.css';
import './styles/p01-workspace.css';
import './styles/p01-active-work.css';
import './styles/p02.css';
import './styles/orders.css';
import './styles/dine-in.css';
import './styles/soldout.css';
import './styles/business-day.css';
import './styles/reporting.css';
import './styles/printing.css';
import './styles/product-config.css';
import './styles/payment.css';
import './styles/shared-shell.css';
import './styles/quick-pending.css';
import './styles/more.css';
import './styles/p01-ios27-layout.css';
import './styles/p01-ios27-overlays.css';
import './styles/p01-rebuild39-search.css';
import './styles/smt-ios27-system.css';
import './styles/p01-donor-2016025.css';
import './styles/smt-donor-checkout.css';
import './styles/smt-donor-full-body.css';
import './styles/smt-operator-layout.css';
import './styles/smt-quick-drink-persistent.css';
import './styles/smt-pairing-workbench.css';
import './styles/smt-pairing-workbench-bridge.css';
import './styles/smt-trial-operation-controls.css';
import './styles/smt-cart-line-mode.css';
import './styles/smt-order-statusbar-ios27.css';
import './styles/smt-status-quota-cart-controls.css';
import './styles/p01-unified.css';
import './styles/p01-unified-extensions.css';

const root=document.getElementById('root');
if(!root) throw new Error('SMT root element missing');

const runtime=resolveSmtRuntime();
if(runtime)signalAndroidRuntimeReady(new URL(window.location.href));

createRoot(root).render(<StrictMode><App runtime={runtime} /></StrictMode>);